import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
const StyledSpan = styled.span(
  ({ theme }) => `
  color: ${theme.colors.gray[60]};
  font-weight: normal;
`
);
const InputOptionalInfo = () => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(StyledSpan, null, t("badges.optional"));
};
export default InputOptionalInfo;
